module.exports = __webpack_public_path__ + "bedroom.png?75c1548a7ff71fe35a72583394167606";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/bedroom.png
// module id = 494
// module chunks = 0